import { render } from "./ClientList.vue?vue&type=template&id=ceb39360&scoped=true"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"

import "../../assets/css/client.css?vue&type=style&index=0&id=ceb39360&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceb39360"]])

export default __exports__